//import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/fontawesome-free/css/all.css'
import 'vue-material-design-icons/styles.css';
import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import colors from 'vuetify/lib/util/colors'

Vue.use(Vuetify);

export default new Vuetify({
    icons: {
        iconfont: "mdiSvg" || "md" || "fa" || "mdi",
    },
    theme: {
        themes: {
            light: {
                primary: colors.green.lighten2,
                secondary: colors.blue.lighten5,
                accent: colors.green.lighten2,
                error: colors.red.lighten3,
                info: colors.cyan.lighten1,
                success: colors.green,
                warning: colors.amber,
            },
        },
    },
});
